import { combineReducers } from '@reduxjs/toolkit';
import analyticReducer from './analytic.store';
import userReducer from './user.store';

const rootReducer = combineReducers({
  user: userReducer,
  analytic: analyticReducer,
});

export default rootReducer;
